/* 商品の札（予約／SOLD OUT／残りわずか）を決めるのはここ1か所だけ。グリッドはどれもこれを使う。
   ・予約（タグに「予約販売」または「受注会」）は、在庫が無くても SOLD OUT にしない
     ＝「蓮刺繍トラックジャケット ※予約※（11月初旬入荷）」のような品を売り切れに見せないため
   ・買える変種が1つも無ければ SOLD OUT（写真を薄くして、買えないと分かるようにする）
   ・残りわずかは rr-qty.json（通販ロケーションの実数）だけを見る。
     Liquid の合計は店頭マイナスで嘘になるので使わない */
window.RRQTY=(function(){
  var d=window.RRQTY_SRC;                      /* assets/rr-qty.js がページに焼いてある */
  if(!d||!d.qty||!d.at) return null;
  /* 日付の関門：古い表で「残りわずか」と言わない（在庫は毎日動く） */
  var age=(Date.now()-Date.parse(d.at))/36e5;
  if(!(age>=0)||age>36){ console.warn("残りわずかの表が"+Math.round(age)+"時間前のものなので使いません"); return null }
  return d.qty;
})();
/* 受注会のタグは会が終わっても商品に残る。終わった会のタグで「予約」と言わないための会期表。
   🔴 2026-11-03 実測：予約の札が出る8点すべてで札が間違っていた。
      ・蓮刺繍トラックジャケット ※予約※ … 売り切れで1点も買えないのに「予約」
      ・2026AWの7点 … 受注会2026AW(〜10/18)のタグが残っているだけで、いまは在庫から
        普通に売れる（かごの口で4〜9点まで入ることを実測）。「予約」と書くと取り寄せに見える
   新しい受注会を始めたら、ここに1行足す。無い札は「開催中」とみなす */
window.RRJUCHUKAI={"受注会2026AW":"2026-10-18"};
window.RRSTOCK=function(p){
  var ts=((p&&p.tags)||[]);
  var av=((p&&p.variants)||[]).some(function(v){return v.available});
  /* 🔴 買えない物は必ず SOLD OUT。タグで隠さない（押してから買えないと分かるのが一番落胆させる） */
  if(!av) return {cls:"is-so", tag:"SOLD OUT"};
  var owari=function(t){ var d=window.RRJUCHUKAI[t];
    return d ? (new Date(d+"T23:59:59+09:00") < new Date()) : false };
  var ikiteru=false, yoyaku=false;
  for(var i=0;i<ts.length;i++){
    if(ts[i].indexOf("予約")>-1) yoyaku=true;
    if(ts[i].indexOf("受注会")>-1 && !owari(ts[i])) ikiteru=true;
  }
  /* 予約＝「予約販売」のタグがあって、まだ買えて、終わった受注会の品ではないもの */
  var juchukai = ts.some(function(t){return t.indexOf("受注会")>-1});
  if(yoyaku && (!juchukai || ikiteru)) return {cls:"is-yo", tag:"予約"};
  var q=window.RRQTY&&window.RRQTY[p&&p.handle];
  if(typeof q==="number"&&q>=1&&q<=2) return {cls:"is-few", tag:"残りわずか"};
  return {cls:"", tag:""};
};

const RRA="//rourou.com/cdn/shop/t/34/assets/rr-o-P04.webp?v=134979840794102008131793421898".replace(/rr-o-P04\.webp.*$/,"");
/* かたまり0 */

const G={kinchaku:["朧朧国巾着",1800],scarf:["朧朧国マルチウェイスカーフ",12000],hairband:["朧朧国ヘアバンド",3800],pouch:["朧朧国バルーンポーチ",2200],fan:["朧朧国扇子",2500],
 socks2:["スニーカージャカードソックス 新蓮唐草",2400],nw0:["蓮刺繍トラックジャケット（予約・11月初旬入荷）",15400],nw1:["蓮刺繍ロングスリーブドライT",6600],nw2:["チャイナギャザーパンツ",19800],nw3:["2026AW蓮刺繍ニットストール",19000],nw4:["2026AW蓮刺繍テーパードパンツ",26000],nw5:["2026AW蓮刺繍スタンドカラーワンピース",36000],nw6:["2026AW蓮刺繍ニットカーディガン",25000],nw7:["2026AWブラックアイリスフレアースカート",22000],nw8:["2026AWブラックアイリスチュニックワンピース",25000],nw9:["2026AWチャイナ釦ファーブルゾン",48000],nw10:["朧朧国巾着",1800],nw11:["カラフルプリントロングスリーブカットソー",11000],nw12:["カラフルプリントZIPUPパーカー",15000],nw13:["朧朧国バルーンポーチ",2200],nw14:["オパールプリントヘアバンド",3800],nw15:["餃子キーホルダー",800],nw16:["蓮とムーンストーンのネックレス",23000],nw17:["蓮刺繍フレアースリーブワンピース",23800],nw18:["蓮刺繍フレアースリーブカットソー",13800],nw19:["Keeda蓮ヘアバンド",3800],nw20:["ROUROUヘアバンド3",3800],nw21:["ロータスレースチュールポーチM",3300],nw22:["ルーズパンダT（2026）",8000],nw23:["猫刺繍トートバッグ",11000],lk_op:["LOTUS唐草プリントワンピース",28000],lk_sk:["LOTUS唐草サッシュリボン付きスカート",23000],lk_tote:["モノグラムハンドルキャンバストート",7700],lk_chu:["LOTUS唐草シュシュ",1300],socks:["スニーカージャカードソックス パンダ",2400],
 fur:["チャイナ釦ファーブルゾン",48000],dress:["蓮刺繍スタンドカラーワンピース",36000],knit:["蓮刺繍ニットカーディガン",25000],skirt:["ブラックアイリスフレアースカート",22000],
 duo:["ブラックアイリスチュニックワンピース",25000],stole:["蓮刺繍ニットストール",19000],track:["蓮刺繍トラックジャケット",15400],print:["カラフルプリントロングスリーブカットソー",11000],neck:["蓮とムーンストーンのネックレス",23000]};
const yen=n=>"¥"+n.toLocaleString("ja-JP");
const card=k=>`<a href="#"><div class="im"><img src="${RRA}rr-p-${k}.webp" alt="${G[k][0]}" loading="lazy"></div><p>${G[k][0]}<span class="pr">${yen(G[k][1])}</span></p></a>`;
/* 柄の段＝本店の /products.json から。柄は①バリアントのオプション（柄・色・カラー）の値 ②商品名に入る柄の名前 の2つで拾う。在庫ありのみ・新しい柄が先頭 */
(function(){
  const box=document.getElementById("fromOboro"),chips=document.getElementById("garaChips"),btn=document.getElementById("garaMore"),h=document.getElementById("garaH");
  if(!box||!chips) return;
  // 色の名前は柄ではない
  const COLORS=new Set(["ブラック","ネイビー","グリーン","パープル","ブルー","グレージュ","グレー","マスタード","クリーム","ホワイト","ボルドー","ピンク","ベージュ","レッド","イエロー","オレンジ","ブラウン","カーキ","ターコイズ","エメラルド","エメラルドグリーン","サックスブルー","パウダーグリーン","アクアカルセドニー","ピンクカルセドニー","ワンカラー","シルバー","ゴールド","チャコール","オフホワイト","ライトグレー","ワインレッド","モカ","生成り","黒","白","紺","ルビーピンク","モノグラム"]);
  // バリアントに柄が無い今季の柄は、商品名から拾う（部分一致は説明文まで見ないので混ざらない）
  const BY_NAME=["2026AW蓮刺繍","蓮刺繍","ブラックアイリス","朧朧国","カラフルプリント","フラワープリント","新蓮唐草"];
  const MAX_CHIPS=14;
  const yen=n=>"¥"+Number(n).toLocaleString("ja-JP");
  const thumb=u=>u?(u+(u.indexOf("?")>-1?"&":"?")+"width=480"):"";
  const card=x=>'<a class="gd'+(x.st.cls?' '+x.st.cls:'')+'" href="/products/'+x.h+'"><div class="im"><img src="'+x.i+'" alt="'+x.t.replace(/"/g,"&quot;")+'" loading="lazy"></div><p>'+x.t+'<span class="pr">'+yen(x.p)+(x.st.tag?'<em class="so-t">'+x.st.tag+'</em>':'')+'</span></p></a>';
  let GP={},ORDER=[],cur="",n=0;
  function draw(){ chips.innerHTML=ORDER.map(function(g){return '<button type="button" data-g="'+g+'" aria-pressed="'+(g===cur)+'">'+g+'<small>'+GP[g].length+'</small></button>'}).join("");
    chips.querySelectorAll("button").forEach(function(b){b.onclick=function(){pick(b.dataset.g)}}); }
  function more(){ const L=GP[cur]; const step=n===0?4:6; L.slice(n,n+step).forEach(function(x){box.insertAdjacentHTML("beforeend",card(x))}); n+=step;
    const left=L.length-n; if(btn){ btn.hidden=left<=0; btn.textContent="続きを見る（あと"+left+"点）"; } box.classList.toggle("three",n<=3); }
  function pick(g){ cur=g; n=0; box.innerHTML=""; if(h) h.textContent=g+"の柄から"; more(); draw(); }
  if(btn) btn.onclick=more;
  fetch("/products.json?limit=250").then(function(r){return r.json()}).then(function(d){
    const ps=d.products   /* 売り切れも残す（2026-11-02 ボス「売れている賑わいが出るし逆に購買意欲がそそられる」）*/;
    const map={};
    function add(g,p){ const im=(p.images&&p.images[0]&&p.images[0].src)||"";
      (map[g]=map[g]||[]); if(map[g].some(function(x){return x.h===p.handle})) return;
      map[g].push({h:p.handle,t:p.title,p:Math.round(Number(p.variants[0].price)),i:thumb(im),d:p.published_at,st:RRSTOCK(p)}); }
    ps.forEach(function(p){
      (p.options||[]).forEach(function(o){
        if(["柄","色","カラー","デザイン"].indexOf(o.name)>=0){
          (o.values||[]).forEach(function(v){ v=(v||"").trim();
            if(v && !COLORS.has(v) && !/^[A-Za-z0-9 .\-\/]+$/.test(v) && v.length<=20) add(v,p); });
        }
      });
      // 商品名から（長い名前を先に見て、二重に入らないようにする）
      for (var i=0;i<BY_NAME.length;i++){ var g=BY_NAME[i];
        if(p.title.indexOf(g)>=0){ add(g==="2026AW蓮刺繍"?"蓮刺繍":g, p); break; } }
    });
    // その柄の一番新しい商品が新しい順＝最新の柄が先頭
    ORDER=Object.keys(map).filter(function(g){return map[g].length>=2});
    ORDER.forEach(function(g){ map[g].sort(function(a,b){return new Date(b.d)-new Date(a.d)}) });
    ORDER.sort(function(a,b){ return new Date(map[b][0].d)-new Date(map[a][0].d) });
    ORDER=ORDER.slice(0,MAX_CHIPS);
    if(!ORDER.length) return;
    ORDER.forEach(function(g){ GP[g]=map[g] });
    pick(ORDER[0]);
  }).catch(function(e){ console.warn("柄の段の読み込みに失敗",e) });
})();
/* 新着順＝本店の /products.json から。在庫ありを公開日の新しい順に24点・8点ずつ「もっと見る」・種類で絞れる */
(function(){
  const box=document.getElementById("newGoods"),btn=document.getElementById("newMore"),tb=document.getElementById("newType");
  if(!box||!box.closest("section")) return;
  const TYPES=["すべて","洋服","ストール・スカーフ","バッグ","小物","アクセサリー"];
  const kind=t=>/ストール|スカーフ/.test(t)?"ストール・スカーフ":/バッグ|トート/.test(t)?"バッグ":/ヘアバンド|ネックレス|ブレスレット|ピアス|イヤリング|コンチョ/.test(t)?"アクセサリー":/巾着|ポーチ|キーホルダー|ソックス|タイツ|ハンカチ|扇子|ベレー|ハンドウォーマー/.test(t)?"小物":"洋服";
  const yen=n=>"¥"+Number(n).toLocaleString("ja-JP");
  const thumb=u=>u?u.replace(/(\.[a-zA-Z]+)(\?|$)/,"$1?")+ (u.indexOf("?")>-1?"&":"") + "width=480":"";
  const card=x=>'<a class="gd'+(x.st.cls?' '+x.st.cls:'')+'" href="/products/'+x.h+'"><div class="im"><img src="'+x.i+'" alt="'+x.t.replace(/"/g,"&quot;")+'" loading="lazy"></div><p>'+x.t+'<span class="pr">'+yen(x.p)+(x.st.tag?'<em class="so-t">'+x.st.tag+'</em>':'')+'</span></p></a>';
  let ALL=[],TOTAL=0,cur="すべて",NW=[],n=0;
  if(btn) btn.addEventListener("click",function(e){ if(n<NW.length){ e.preventDefault(); more(); } });
  function drawType(){ if(!tb) return;
    tb.innerHTML=TYPES.map(function(t){var c=t==="すべて"?ALL.length:ALL.filter(function(x){return kind(x.t)===t}).length;return '<button type="button" data-t="'+t+'" aria-pressed="'+(t===cur)+'">'+t+'<small>'+c+'</small></button>'}).join("");
    tb.querySelectorAll("button").forEach(function(b){b.onclick=function(){setType(b.dataset.t)}}); }
  function more(){ NW.slice(n,n+8).forEach(function(x){box.insertAdjacentHTML("beforeend",card(x))}); n+=8;
    if(btn){ if(n>=NW.length){ btn.textContent = cur==="すべて" ? ("すべての商品を見る（"+TOTAL+"点）") : (cur+"をすべて見る"); btn.setAttribute("href", cur==="すべて" ? "/collections/all" : "/collections/all"); } else { btn.textContent="もっと見る"; btn.setAttribute("href","#new"); } } }
  function setType(t){ cur=t; NW = t==="すべて" ? ALL : ALL.filter(function(x){return kind(x.t)===t}); n=0; box.innerHTML=""; more(); drawType(); }
  fetch("/products.json?limit=250").then(function(r){return r.json()}).then(function(d){
    var ps=d.products   /* 売り切れも残す（2026-11-02 ボス「売れている賑わいが出るし逆に購買意欲がそそられる」）*/;
    TOTAL=ps.length;
    ALL=ps.sort(function(a,b){return new Date(b.published_at)-new Date(a.published_at)}).slice(0,24).map(function(p){
      var im=(p.images&&p.images[0]&&p.images[0].src)||"";
      return {h:p.handle,t:p.title,p:Math.round(Number(p.variants[0].price)),i:thumb(im), st:RRSTOCK(p)};
    });
    setType("すべて");
  }).catch(function(e){ console.warn("新作の読み込みに失敗",e); });
})();
/* 1画面目：開くたびにランダムで1枚。自動では流さない */
const HERO={
 jc:{pics:[["jc1","蓮刺繍ニットストールを肩に掛けた2人"],["jc2","ストールを掛けて歩く2人の後ろ姿"],["jc3","チャイナ釦ファーブルゾンの2人"],["jc4","チャイナ釦ファーブルゾン"],["jc5","ブラックアイリスチュニックワンピースの2人"],["jc6","ファーブルゾンを着て緑の中に立つ"],["jc7","スタンドカラーワンピースで歩く2人"]],
  until:"2026-10-18",   /* 会期の最終日。過ぎたらこの画は出さない（B案の関門④） */
  tx:()=>`<span class="lab">秋冬受注会</span><h1 class="big">Trace</h1><span class="when"><span class="nw">10.6 火 – 10.18 日</span>　<span class="nw">横浜中華街店・オンライン</span></span><a class="btn" href="#new">受注会の服を見る</a>`},
 /* 普段の1画面目＝1スライド1商品（2026-11-02 B案・7人衆会議の確定／ボス承認）。
    見出し・値段・写真3枚・行き先の4つを、必ず同じ1商品から作る。
    前の作りは「写真3枚はばらばらの商品／文字は1枚目の商品だけ」で、2枚目3枚目に
    別の商品が黙って並び、お客様には3枚で1つの商品に見えていた。
    下に書いてある5枚は、商品が取れなかったときの控え（真っ白にしないため）。 */
 nw:{slides:[
   {key:"nw1",head:"蓮刺繍トラックジャケット",title:"蓮刺繍トラックジャケット",price:15400,url:"#new",imgs:["//rourou.com/cdn/shop/t/34/assets/rr-h-nw1.webp?v=23187164690854709091793423171"]},
   {key:"nw2",head:"蓮刺繍フレアースリーブワンピース",title:"蓮刺繍フレアースリーブワンピース",price:23800,url:"#new",imgs:["//rourou.com/cdn/shop/t/34/assets/rr-h-nw2.webp?v=73806651858289001011793423173"]},
   {key:"nw3",head:"カラフルプリントロングスリーブカットソー",title:"カラフルプリントロングスリーブカットソー",price:11000,url:"#new",imgs:["//rourou.com/cdn/shop/t/34/assets/rr-h-nw3.webp?v=3007293006095494591793423175"]},
   {key:"nw4",head:"蓮刺繍フレアースリーブカットソー",title:"蓮刺繍フレアースリーブカットソー",price:13800,url:"#new",imgs:["//rourou.com/cdn/shop/t/34/assets/rr-h-nw4.webp?v=166791236890709738111793423176"]},
   {key:"nw5",head:"カラフルプリントZIPUPパーカー",title:"カラフルプリントZIPUPパーカー",price:15000,url:"#new",imgs:["//rourou.com/cdn/shop/t/34/assets/rr-h-nw5.webp?v=182816642342160717161793423178"]}],
  tx:s=>`<span class="lab">新作</span><h1 class="big ja">${s.head}</h1><span class="when">${yen(s.price)}</span><a class="btn" href="${s.url}">${s.url.slice(0,10)==="/products/"?"この新作を見る":"新作を見る"}</a>`}};
/* ハンドル → 短いキャッチ見出し。入れればそれを、無ければ商品名を見出しにする。
   商品名は日本語で折り返す場所を選べないので、長い品名はここに短い言葉を置くとよい。 */
const CATCH={};
let mode="nw",lastKey="";
const pad2=n=>String(n).padStart(2,"0");
const atq=t=>String(t==null?"":t).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/</g,"&lt;");
function openHero(){const m=HERO[mode];
 if(m.slides){
   const sl=m.slides; if(!sl.length)return;
   let i=Math.floor(Math.random()*sl.length);
   if(sl.length>1&&sl[i].key===lastKey)i=(i+1)%sl.length;
   lastKey=sl[i].key;
   const s=sl[i], nm=atq(s.title||s.head);
   /* 写真はどれを押しても、その商品のページへ行く */
   (document.getElementById("tri")||{}).innerHTML =s.imgs.slice(0,3).map((u,n)=>
     `<a href="${atq(s.url)}"${n?' tabindex="-1" aria-hidden="true"':` aria-label="${nm}"`}><img src="${atq(u)}" alt="${n?"":nm}"></a>`).join("");
   (document.getElementById("heroTx")||{}).innerHTML =m.tx(s);
   (document.getElementById("heroNo")||{}).textContent =pad2(i+1)+" / "+pad2(sl.length);
 }else{
   /* 受注会は1枚1枚が「その回のルック」で、商品1点には紐づかない。従来どおり3枚並べる */
   const set=m.pics.slice();
   for(let k=set.length-1;k>0;k--){const r=Math.floor(Math.random()*(k+1));[set[k],set[r]]=[set[r],set[k]]}
   if(set.length>1&&set[0][0]===lastKey)set.push(set.shift());lastKey=set[0][0];
   const three=set.slice(0,3);
   (document.getElementById("tri")||{}).innerHTML =three.map((q,n)=>`<img src="${RRA}rr-h-${q[0]}.webp" alt="${n?"":atq(q[1])}" ${n?'aria-hidden="true"':""}>`).join("");
   (document.getElementById("heroTx")||{}).innerHTML =m.tx(three[0]);
   const idx=m.pics.findIndex(q=>q[0]===three[0][0]);
   (document.getElementById("heroNo")||{}).textContent =pad2(idx+1)+" / "+pad2(m.pics.length);
 }
 /* 品名が長いと1画面目の枠を超えて右端で切れる（2026-11-02 実測：自動にして本物の品名が入るようになってから）。
    会議の確定は「見出しは文節ごとに折る」だが、商品名を文節で割る辞書は無く、変な所で折ると
    かえって読みにくい（ボスが以前「センスがない」と指摘した件）。だから折らずに字を詰める。
    12文字までは今までどおり。それより長い分だけ比例で小さくして、必ず1行に収める */
 (function(){try{
  var h=document.querySelector("#heroTx .big.ja"); if(!h) return;
  /* 測り方の失敗を2つ踏んだので記録しておく（2026-11-02 実測）。
     ① scrollWidth は overflow:visible だと枠の幅を返すだけで、はみ出しを測れない。
     ② 本物に white-space:nowrap を当てて測ると、その瞬間にグリッドの列が内容幅まで広がり、
        スマホ幅で枠が画面より広いまま残って横に切れた。
     だから本物には一切触らず、画面の外に置いた複製で measure する */
  /* 会議の確定「見出しは文節ごとに inline-block で折る」を1画面目にも効かせる。
     商品名を文節に割る辞書は無いので、文字の種類が変わる所（漢字／カタカナ／英数）で塊にする。
     ひらがな・1文字の塊・記号は直前にくっつける＝「ダブルハピネスコンチョ付き／ベレー帽」
     「蓮刺繍／ロングスリーブドライT」のように、読める単位で折れる。 */
  var kind=function(c){
    if(/[ァ-ヶーｦ-ﾟ･]/.test(c))return "k";
    if(/[一-龠々〆]/.test(c))return "j";
    if(/[ぁ-ん]/.test(c))return "h";
    if(/[A-Za-z0-9]/.test(c))return "e";
    return "s";
  };
  var phrase=function(t){
    var a=[],cur="",ct="";
    for(var i=0;i<t.length;i++){
      var c=t[i],k=kind(c);
      if(k==="h"||k==="s"||(k===ct)||cur===""){           /* ひらがな・記号は前の塊に付ける */
        if(cur===""){ct=k} cur+=c;
        if(k!=="h"&&k!=="s")ct=k;
      }else{ a.push(cur); cur=c; ct=k }
    }
    if(cur)a.push(cur);
    /* 2文字以下の塊は前にくっつける（「帽」「T」が独りぼっちにならないように） */
    var out=[];
    for(var j=0;j<a.length;j++){
      if(out.length&&Array.from(a[j]).length<=2){ out[out.length-1]+=a[j] } else out.push(a[j]);
    }
    return out;
  };
  (function(){
    var t=h.textContent.trim(), ps=phrase(t);
    if(ps.length>1&&ps.join("")===t){
      h.innerHTML=ps.map(function(x){return '<span class="ph">'+
        x.replace(/&/g,"&amp;").replace(/</g,"&lt;")+'</span>'}).join("");
    }
  })();

  /* 幅から行数を計算しようとすると、英字が途中で折れる分だけ読み違える（実測で3行になった）。
     出来上がった高さから実際の行数を数えて、収まるまで2pxずつ落とす。 */
  var fit=function(){
    h.style.fontSize="";
    /* スマホは2行まで許す。ただし塊が1つしか取れない品名（全部カタカナ等）は
       どこで折っても中途半端になるので、1行に収まるまで縮める */
    var cap=(h.clientWidth<520 && h.querySelectorAll(".ph").length>1)?2:1;
    var rows=function(){var c=getComputedStyle(h),lh=parseFloat(c.lineHeight);
      return lh?Math.round(h.getBoundingClientRect().height/lh):1};
    var px=parseFloat(getComputedStyle(h).fontSize), n=0;
    while(rows()>cap && px>20 && n++<16){ px-=2; h.style.fontSize=px+"px" }
  };
  fit(); addEventListener("resize",fit,{passive:true});
 }catch(e){}})();
}
/* 終わった受注会を出し続けない（B案の関門④）。会期の最終日を過ぎたら普段の画に固定する。
   10/31の公開前にも、終わった「Trace」が現役のように出ていて会議で指摘された。 */
(function(){try{
 var u=HERO.jc&&HERO.jc.until;
 if(u&&new Date(u+"T23:59:59+09:00")<new Date()){
   mode="nw";
   var b=document.getElementById("m-jc"); if(b){b.hidden=true;b.disabled=true}
 }
}catch(e){}})();
openHero();
/* 1画面目の新作は、本物の商品から自動で（2026-11-02 ボス「自動にして」＋B案）。
   関門①公開中（/products.json は公開中しか返さない）②在庫あり③写真3枚以上。
   写真が足りない商品は、他の商品の写真で埋めずにスライドごと出さない。
   ＝今回の事故（3枚に別商品が混ざる）を、データの作り方で起こらなくする。
   取れなかったときは上に書いてある5枚がそのまま残る＝真っ白にならない */
(function(){try{
 fetch("/products.json?limit=250").then(function(r){return r.json()}).then(function(d){
  var big=function(u){return u+(u.indexOf("?")>-1?"&":"?")+"width=1200"};
  var ps=(d.products||[]).filter(function(p){
    return p.images&&p.images.length>=3
      &&p.variants&&p.variants.some(function(v){return v.available})});
  ps.sort(function(a,b){return new Date(b.published_at)-new Date(a.published_at)});
  ps=ps.slice(0,8);
  if(ps.length<3)return;                       /* 取れた数が少なすぎたら控えの5枚のまま */
  HERO.nw.slides=ps.map(function(p){
    return {key:p.handle, head:CATCH[p.handle]||p.title, title:p.title,
            price:Math.round(Number(p.variants[0].price)),
            url:"/products/"+p.handle,
            imgs:p.images.slice(0,3).map(function(im){return big(im.src)})}});
  if(mode==="nw")openHero();
 }).catch(function(){});
}catch(e){}})();
const press=(on,off)=>{on.setAttribute("aria-pressed","true");off.setAttribute("aria-pressed","false")};

/* 会員のあいさつ（見本は4通りを切り替え。本番はログインと会員タグで自動） */
(function(){const w=document.getElementById("welcome"),seg=document.getElementById("mem");if(!w||!seg)return;
/* 会議の確定：ヒーローは会員あいさつを出さない＝ブランドの一文を主役に固定（個人あいさつはカートだけ・重なり解消） */
const BRAND='<span class="nw"><ruby>朧朧国<rt>ろうろうこく</rt></ruby>へ</span><span class="nw">ようこそ</span>';
const T={none:BRAND,gen:BRAND,lotus:BRAND,bday:BRAND};
seg.querySelectorAll("button").forEach(b=>b.onclick=()=>{const m=b.dataset.m;w.innerHTML=T[m];w.classList.toggle("bd",m==="bday");seg.querySelectorAll("button").forEach(x=>x.setAttribute("aria-pressed",String(x===b)))});})();

/* ヘッダーのメニュー：別のページにいても、トップの段へ飛ぶ */
document.querySelectorAll(".enav a[href^='#']:not([data-go])").forEach(a=>a.addEventListener("click",e=>{const id=a.getAttribute("href").slice(1);const t=document.getElementById(id);if(!t)return;e.preventDefault();if(t.closest(".page")&&t.closest(".page").hidden)showPage("top");setTimeout(()=>window.scrollTo({top:t.getBoundingClientRect().top+scrollY-70,behavior:"instant"}),30);}));
const mj=document.getElementById("m-jc"),mn=document.getElementById("m-nw");
mj.onclick=()=>{mode="jc";(document.getElementById("notice")||{}).hidden =false;press(mj,mn);openHero()};
mn.onclick=()=>{mode="nw";(document.getElementById("notice")||{}).hidden =true;press(mn,mj);openHero()};
document.getElementById("again").onclick=()=>{showPage("top");openHero()};
const PAGES=["top","concept","pdp","cart","col","shop","uni","blist","bpost","bm","ops"];
var _histLock=false;function showPage(p){document.body.classList.toggle("oncart",p==="cart");PAGES.forEach(x=>{document.getElementById("pg-"+x).hidden=x!==p});document.querySelectorAll("#pages button").forEach(b=>b.setAttribute("aria-pressed",String(b.dataset.p===p)));window.scrollTo({top:0,behavior:"instant"});wakeVideos();if(!_histLock){try{history.pushState({p:p},"","#"+p)}catch(e){}}}
addEventListener("popstate",function(e){_histLock=true;try{showPage((e.state&&e.state.p)||"top")}finally{_histLock=false}});
document.getElementById("pages").addEventListener("click",e=>{const b=e.target.closest("button");if(b)showPage(b.dataset.p)});
document.querySelectorAll("[data-go]").forEach(a=>a.addEventListener("click",e=>{e.preventDefault();showPage(a.dataset.go)}));
(document.getElementById("colGoods")||{}).innerHTML =["fur","dress","knit","skirt","duo","stole"].map(card).join("");
(document.getElementById("bmGoods")||{}).innerHTML =["track","scarf","stole"].map(card).join("");
/* 「朧朧国へようこそ」（会員のあいさつに変わっても）を押すと、朧朧国のこと（コンセプト）へ */
{const w=document.getElementById("welcome");if(w){w.classList.add("go");w.setAttribute("role","link");w.tabIndex=0;w.setAttribute("aria-label","朧朧国のことを読む");const go=()=>showPage("concept");w.addEventListener("click",go);const ws=document.getElementById("wsub");if(ws)ws.addEventListener("click",go);w.addEventListener("keydown",e=>{if(e.key==="Enter")go()})}}
document.querySelectorAll("[data-jump]").forEach(a=>a.addEventListener("click",e=>{e.preventDefault();showPage("top");setTimeout(()=>{const t=document.getElementById(a.dataset.jump);if(t)window.scrollTo({top:t.getBoundingClientRect().top+scrollY-70,behavior:"instant"})},40)}));
document.addEventListener("click",e=>{const a=e.target.closest("[data-gosec]");if(!a)return;e.preventDefault();showPage("concept");setTimeout(()=>{const t=document.getElementById(a.dataset.gosec);if(t)window.scrollTo({top:t.getBoundingClientRect().top+scrollY-20,behavior:"instant"})},40)});
/* 旅するROUROU：ブログ投稿ページで「催事」に印を付けた記事（会期・場所つき）から自動で並ぶ。読めない時は手で書いた行のまま */
(async()=>{try{const r=await fetch("https://rourou-blog-studio.pages.dev/api/events");const j=await r.json();if(!j.ok||!j.events||!j.events.length)return;
  const W="日月火水木金土",esc=t=>String(t??"").replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  const p=d=>{const[y,m,dd]=d.split("-").map(Number);return{t:m+"."+dd,w:W[new Date(Date.UTC(y,m-1,dd)).getUTCDay()]}};
  (document.getElementById("evRows")||{}).innerHTML =j.events.map(e=>{const a=p(e.start),b=p(e.end),one=e.start===e.end;
    const s=e.state==="done"?"終わりました":e.state==="now"?"開催中":e.link?"くわしく":"ご案内は追って";
    const h=e.link?` href="${esc(e.link)}" target="_blank" rel="noopener"`:` href="#ev"`;
    return `<a${h}><span class="d">${one?a.t:a.t+"–"+b.t}<small>${one?a.w:a.w+"–"+b.w}</small></span><span class="t">${esc(e.name)}<span>${esc(e.place)}</span></span><span class="s${e.state==="now"?" on":""}">${s}</span></a>`}).join("")}
  catch(e){}})();

/* フッター：全部のページの下に同じ案内を足す（下の1行＝ロゴ・各ページの小物はそのまま） */
document.querySelectorAll("footer.ft").forEach(f=>{if(f.previousElementSibling&&f.previousElementSibling.classList.contains("ftr"))return;const n=document.getElementById("ftRich").content.firstElementChild.cloneNode(true);f.before(n);n.querySelectorAll("[data-go]").forEach(a=>a.addEventListener("click",e=>{e.preventDefault();showPage(a.dataset.go)}));n.querySelectorAll('a[href^="#"]:not([data-go])').forEach(a=>a.addEventListener("click",e=>{const t=document.getElementById(a.getAttribute("href").slice(1));if(!t)return;e.preventDefault();if(t.closest(".page")&&t.closest(".page").hidden)showPage("top");setTimeout(()=>window.scrollTo({top:t.getBoundingClientRect().top+scrollY-70,behavior:"instant"}),30)}))});


/* 動画: 画面に入った時だけ読み込んで再生。動きを減らす設定なら止めた絵のまま */
const still=matchMedia("(prefers-reduced-motion: reduce)").matches;
const io="IntersectionObserver" in window?new IntersectionObserver(es=>es.forEach(e=>{const v=e.target;
  if(e.isIntersecting){if(!v.src&&v.dataset.src)v.src=v.dataset.src;if(!still)v.play().catch(()=>{})}else v.pause()}),{rootMargin:"200px"}):null;
function wakeVideos(){document.querySelectorAll("video[data-src]").forEach(v=>{if(io)io.observe(v)});checkVids()}
/* 見張りが反応しない端末のために、スクロールのたびにも確かめる */
let ckq=false;
function checkVids(){ckq=false;document.querySelectorAll("video[data-src]").forEach(v=>{if(!v.offsetParent)return;const r=v.getBoundingClientRect();const inView=r.top<innerHeight+200&&r.bottom>-200;
  if(inView){if(!v.getAttribute("src"))v.src=v.dataset.src;if(!still&&v.paused)v.play().catch(()=>{})}else if(!v.paused)v.pause()})}
addEventListener("scroll",()=>{if(!ckq){ckq=true;setTimeout(checkVids,120)}},{passive:true});
addEventListener("resize",checkVids);addEventListener("pageshow",checkVids);
setInterval(checkVids,800);
wakeVideos();

/* 朧朧国: 止まった絵を先に出し、部品が全部読めたら動き出す（黒い待ち画面は出さない） */
(function(){const st=document.getElementById("artstage");if(!st)return;st.classList.add("live");
  setInterval(()=>{const r=st.getBoundingClientRect();st.classList.toggle("paused",r.bottom<0||r.top>innerHeight||document.hidden||!st.offsetParent)},700);})();
(function(){const st=document.getElementById("stage");if(!st)return;const ims=[...st.querySelectorAll(".pt img")];let left=ims.length+1;
  const go=()=>{if(--left===0)st.classList.add("live")};
  ims.forEach(im=>{if(im.complete)go();else{im.addEventListener("load",go,{once:true});im.addEventListener("error",go,{once:true})}});
  const pre=new Image();pre.onload=go;pre.onerror=go;pre.src="//rourou.com/cdn/shop/t/34/assets/rr-o-bg.webp?v=41414199308747274741793421917";
  setInterval(()=>{const r=st.getBoundingClientRect();st.classList.toggle("paused",r.bottom<0||r.top>innerHeight||document.hidden)},700);})();
/* かたまり2 */
(function(){try{if(!("IntersectionObserver" in window))return;if(matchMedia("(prefers-reduced-motion:reduce)").matches)return;var root=document.getElementById("pg-top");if(!root)return;var sel="section:not(#top) h2, section:not(#top) .lede2, #pg-top .goods, #pg-top .ph-row, #pg-top figure";var els=[].slice.call(root.querySelectorAll(sel));if(!els.length)return;els.forEach(function(el){el.setAttribute("data-ruf","");});document.documentElement.classList.add("ruf-on");var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("ruf-seen");io.unobserve(e.target);}});},{threshold:.12,rootMargin:"0px 0px -6% 0px"});els.forEach(function(el){io.observe(el);});}catch(e){try{document.documentElement.classList.remove("ruf-on");}catch(_){}}})();
/* かたまり3 */
(function(){var pg=document.getElementById("pg-concept"),h=document.getElementById("cptHero");if(!pg||!h)return;if(matchMedia("(prefers-reduced-motion:reduce)").matches||!("MutationObserver" in window))return;h.classList.add("armed");function upd(){if(!pg.hasAttribute("hidden")){h.classList.remove("in");void h.offsetWidth;h.classList.add("in");}else{h.classList.remove("in");}}new MutationObserver(upd).observe(pg,{attributes:true,attributeFilter:["hidden"]});upd();})();
/* かたまり4 */
(function(){if(matchMedia("(prefers-reduced-motion:reduce)").matches||!("IntersectionObserver" in window)||!("MutationObserver" in window))return;var heads=[].slice.call(document.querySelectorAll(".rr-head"));if(!heads.length)return;heads.forEach(function(h){h.classList.add("armed");var pg=h.closest?h.closest(".page"):null;function play(){h.classList.remove("in");void h.offsetWidth;h.classList.add("in");}function reset(){h.classList.remove("in");}if(pg&&pg.id!=="pg-top"){function upd(){if(!pg.hasAttribute("hidden"))play();else reset();}new MutationObserver(upd).observe(pg,{attributes:true,attributeFilter:["hidden"]});upd();}else{var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)h.classList.add("in");else h.classList.remove("in");});},{threshold:.3});io.observe(h);}});})();
/* かたまり5 */
(function(){if(matchMedia("(prefers-reduced-motion:reduce)").matches||!("IntersectionObserver" in window))return;var secs=[].slice.call(document.querySelectorAll("#new,#make,#art,#ev,#blog"));secs.forEach(function(el){if(!el.querySelector(".sec-mot"))return;el.classList.add("sec-arm");});var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("inview");}});},{threshold:.2});secs.forEach(function(el){io.observe(el);});})();
/* かたまり6 */
/* rr-tshot */
/* Today's Shot。公開中のものだけを返す口（/api/tshot-public）から読む。
   2026-11-02 ボス「写真をクリックして大きく見たい」「ストックをこのページで見たい」。
   最初は6枚だけ。写真を押すとその場で大きく見られる。「これまでのショット」で12枚ずつ足す。
   100枚あっても最初に読むのは6枚＝トップは重くならない。大きい写真は押した時に初めて読む。 */
(function(){
  var API="https://rourou-blog-studio.pages.dev/api/tshot-public";
  var sec=document.getElementById("tshot"), box=document.getElementById("tshots");
  var moreWrap=document.getElementById("tsMoreWrap"), more=document.getElementById("tsMore");
  if(!sec||!box) return;
  var esc=function(t){return String(t==null?"":t).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")};
  var ymd=function(at){var d=new Date(at);return isNaN(d.getTime())?"":d.getFullYear()+"."+("0"+(d.getMonth()+1)).slice(-2)+"."+("0"+d.getDate()).slice(-2)};
  var seen={}, store={}, cursor=null, busy=false;
  var card=function(p){
    return '<div class="tsc">'+
      '<button type="button" class="tsc-b" data-k="'+esc(p.id)+'" aria-label="'+esc((p.name||"この")+"方の写真を大きく見る")+'">'+
      '<img src="'+esc(p.thumb||p.photo)+'" alt="" loading="lazy" decoding="async"></button>'+
      '<span class="tsc-who">'+esc(p.name)+'</span>'+
      '<span class="tsc-say">'+esc(p.body)+'</span>'+
      '<span class="tsc-d">'+ymd(p.at)+'</span></div>';
  };
  var load=function(n,before){
    if(busy) return Promise.resolve([]);
    busy=true;
    if(more) more.disabled=true;
    var url=API+"?n="+n+(before?("&before="+encodeURIComponent(before)):"");
    return fetch(url).then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json() })
      .then(function(d){
        var rows=(d&&d.ok&&d.rows)||[], html="";
        rows.forEach(function(p){ if(seen[p.id])return; seen[p.id]=1; store[p.id]=p; html+=card(p) });
        if(html) box.insertAdjacentHTML("beforeend",html);
        cursor=(d&&d.next)||null;
        /* 続きを取る口がまだ無い／もう続きが無い ときは「これまでのショット」を出さない */
        if(moreWrap) moreWrap.hidden=!cursor;
        busy=false; if(more) more.disabled=false;
        return rows;
      }).catch(function(e){ busy=false; if(more) more.disabled=false;
        console.warn("Today's Shot", e&&e.message); return [] });
  };
  /* 最初の6枚。「今日の一枚」と名乗る段なので、60日より新しいものが1枚も無ければ段ごと出さない
     （貯めた物が腐って出続ける事故を止める関門。もっと見るで出る過去の分はこの関門の外） */
  load(6).then(function(rows){   /* 既定6枚。試すときだけ window.__TSN で変えられる */
    var now=Date.now();
    var fresh=rows.filter(function(p){var t=Date.parse(p.at);return !t||now-t<60*864e5});
    if(!fresh.length){ console.warn("Today's Shot は出せる分が無いので段を出しません"); return }
    sec.removeAttribute("hidden");
  });
  if(more) more.addEventListener("click",function(){ if(cursor) load(12,cursor) });

  /* 押したら大きく見る */
  var bx=document.getElementById("tsbox"), im=document.getElementById("tsboxIm"),
      who=document.getElementById("tsboxWho"), say=document.getElementById("tsboxSay"),
      dd=document.getElementById("tsboxD"), xx=document.getElementById("tsboxX"), opener=null;
  var shut=function(){
    if(!bx||bx.hidden) return;
    bx.hidden=true; im.removeAttribute("src");
    document.documentElement.style.overflow="";
    if(opener&&opener.focus) opener.focus();
  };
  box.addEventListener("click",function(e){
    var b=e.target.closest&&e.target.closest(".tsc-b"); if(!b||!bx) return;
    var p=store[b.getAttribute("data-k")]; if(!p) return;
    opener=b;
    im.src=p.photo||p.thumb;                        /* 大きい写真はここで初めて読む */
    im.alt=(p.name?p.name+"さんの写真":"Today's Shot の写真");
    who.textContent=p.name||""; say.textContent=p.body||""; dd.textContent=ymd(p.at);
    bx.hidden=false; document.documentElement.style.overflow="hidden";
    if(xx) xx.focus();
  });
  if(xx) xx.addEventListener("click",shut);
  if(bx) bx.addEventListener("click",function(e){ if(e.target===bx) shut() });
  addEventListener("keydown",function(e){ if(e.key==="Escape") shut() });
})();
/* かたまり7 */
/* rr-replay-motif */
/* モチーフは「開いた瞬間」ではなく「スクロールされてから」動く（2026-11-02 ボスの指示）。
   2026-11-02 追記：10秒ごとに頭から流し直していたが、動いている途中で0%へ飛ぶので
   「動きが終わったあとカクッと元の位置に戻る」（ボスの指摘）。
   流し直すのをやめ、CSS側を往復（alternate）の無限ループにした＝行って戻るで切れ目が無い。 */
(function(){try{
if(matchMedia("(prefers-reduced-motion:reduce)").matches)return;
var armed=false;
function arm(){ if(armed)return; armed=true;
  document.documentElement.classList.add("scrolled"); }
["scroll","wheel","touchmove","pointerdown","keydown"].forEach(function(ev){
  addEventListener(ev,arm,{once:true,passive:true});
  document.addEventListener(ev,arm,{once:true,passive:true});
});
/* 保険：合図が取りこぼされても、少しでも下へ動いていたら動かす */
var _watch=setInterval(function(){
  if(armed){clearInterval(_watch);return}
  if((window.scrollY||document.documentElement.scrollTop||0)>8){ arm(); clearInterval(_watch); }
},250);
}catch(e){}})();
/* かたまり8 */
/* ヒーローを抜けたらヘッダーに地を敷く */
(function(){try{
  var hd=document.querySelector(".hd"); if(!hd) return;
  var hero=document.getElementById("top"); if(!hero) return;
  if(!("IntersectionObserver" in window)){hd.classList.add("solid"); return}
  new IntersectionObserver(function(es){
    es.forEach(function(e){ hd.classList.toggle("solid", !e.isIntersecting) });
  },{rootMargin:"-70px 0px 0px 0px"}).observe(hero);
}catch(e){}})();
/* かたまり9 */

(function(){
 if(typeof showPage!=="function")return;
 var groups=[
  ["見る",[["商品一覧",{ext:"/collections/all"}],["新作",{hash:"new"}],["旅するROUROU（催事）",{hash:"ev"}]]],
  ["知る",[["朧朧国のこと",{ext:"/pages/concept"}],["つくる人",{hash:"make"}],["ブログ",{ext:"/blogs/blog"}]]],
  ["行く",[["お店",{hash:"shop"}],["カフェ",{hash:"cafe"}],["裏の路地へ",{ext:"https://cafe.rourou.com/?utm_source=rourou.com&utm_medium=nav&utm_campaign=cafe_entrance&utm_content=gmenu",cls:"gm-cafe"}],["制服のお仕事",{ext:"/pages/uniform"}]]]
 ];
 var wrap=document.createElement("div");wrap.id="gmenu";wrap.hidden=true;
 var bd=document.createElement("div");bd.className="gm-bd";
 var panel=document.createElement("aside");panel.className="gm-panel";panel.setAttribute("role","dialog");panel.setAttribute("aria-modal","true");panel.setAttribute("aria-label","メニュー");
 var x=document.createElement("button");x.className="gm-x";x.setAttribute("aria-label","閉じる");x.textContent="×";panel.appendChild(x);
 var allLinks=[];
 function addLink(parent,label,o){var a=document.createElement("a");a.href=o.ext||(o.hash?"#"+o.hash:"#top");if(o.cls)a.className=o.cls;if(o.ext){a.target="_blank";a.rel="noopener"}a.textContent=label;a._opt=o;a.addEventListener("click",function(e){e.preventDefault();close();setTimeout(function(){nav(o)},60)});parent.appendChild(a);allLinks.push(a)}
 var topNav=document.createElement("nav");topNav.className="gm-grp gm-top";addLink(topNav,"トップへ",{go:"top"});panel.appendChild(topNav);
 groups.forEach(function(g){var d=document.createElement("div");d.className="gm-grp";var p=document.createElement("p");p.textContent=g[0];d.appendChild(p);g[1].forEach(function(it){addLink(d,it[0],it[1])});panel.appendChild(d)});
 wrap.appendChild(bd);wrap.appendChild(panel);document.body.appendChild(wrap);
 var trig=document.createElement("button");trig.id="gmtrig";trig.setAttribute("aria-label","メニューを開く");trig.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>';document.body.appendChild(trig);
 function open(){markCurrent();wrap.hidden=false;requestAnimationFrame(function(){wrap.classList.add("in")});document.body.style.overflow="hidden"}
 function close(){wrap.classList.remove("in");document.body.style.overflow="";setTimeout(function(){wrap.hidden=true},420)}
 function nav(o){if(o.ext){if(/^https?:/.test(o.ext)){window.open(o.ext,"_blank","noopener")}else{location.href=o.ext}return}if(o.go){showPage(o.go)}if(o.hash){var pt=document.getElementById("pg-top");if(pt&&pt.hidden)showPage("top");var t=document.getElementById(o.hash);if(t)setTimeout(function(){window.scrollTo({top:t.getBoundingClientRect().top+scrollY-70,behavior:"instant"})},40)}}
 function markCurrent(){var cur="top";var vis=document.querySelector(".page:not([hidden])");if(vis&&vis.id)cur=vis.id.replace("pg-","");allLinks.forEach(function(a){a.removeAttribute("aria-current");if(a._opt.go&&a._opt.go===cur)a.setAttribute("aria-current","page")})}
 trig.onclick=open;bd.onclick=close;x.onclick=close;
 document.addEventListener("keydown",function(e){if(e.key==="Escape"&&!wrap.hidden)close()});
 addEventListener("popstate",function(){if(!wrap.hidden)close()});
 document.querySelectorAll(".hd .menu").forEach(function(m){m.addEventListener("click",function(e){e.preventDefault();open()})});
 document.querySelectorAll(".hd .hen--off").forEach(function(a){if(a.textContent.trim()==="SHOP"){a.addEventListener("click",function(e){e.preventDefault();var pt=document.getElementById("pg-top");if(pt&&pt.hidden)showPage("top");var t=document.getElementById("shop");if(t)setTimeout(function(){window.scrollTo({top:t.getBoundingClientRect().top+scrollY-70,behavior:"instant"})},40)})}});
})();

/* かたまり10 */

(function(){
  if(!document.getElementById("pg-shop"))return;
  var P=[
   {t:"2026AWブラックアイリスチュニックワンピース",p:25000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/3_cdc19237-f384-4c9d-bad0-15b5625ed6c6.jpg?width=360",h:"2026awpb",nw:"09-19",up:"10-26",st:"revi"},
   {t:"蓮刺繍ロングスリーブドライT",p:6600,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/634195952320381049.jpg?width=360",h:"hasudryt",nw:"10-01",up:"10-20",st:"few"},
   {t:"2026AW蓮刺繍ニットストール",p:19000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/DSC_1293_52b33cf9-84da-42ad-b325-ef252bfa1582.jpg?width=360",h:"2026awst",nw:"09-19",up:"10-25",st:"revi"},
   {t:"蓮刺繍トラックジャケット",p:15400,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/A00AEFB8-F9AA-45DC-A165-6ADFE0E407C7_b061bf10-2aa2-4b3f-a9ed-61c2a5b78d64.jpg?width=360",h:"lotustcjk-yoyaku",nw:"10-04",up:"10-04",st:"ok"},
   {t:"2026AW蓮刺繍スタンドカラーワンピース",p:36000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/DSC_1206.jpg?width=360",h:"2026awop",nw:"09-19",up:"09-19",st:"ok"},
   {t:"カラフルプリントZIPUPパーカー",p:15000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/PK___1_1698.jpg?width=360",h:"chzppk2609",nw:"09-16",up:"10-24",st:"ok"},
   {t:"ルーズパンダT（2026）",p:8000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/IMG_7084.jpg?width=360",h:"2026lspt",nw:"08-15",up:"08-15",st:"few"},
   {t:"朧朧国巾着",p:1800,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/IMG_3668.jpg?width=360",h:"2026091802",nw:"09-18",up:"09-18",st:"ok"},
   {t:"LOTUS唐草プリントワンピース",p:28000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/DSC_6275.jpg?width=360",h:"25thhasukarakusaop",nw:"07-17",up:"10-22",st:"ok"},
   {t:"パンダジャカードニットプルオーバー",p:18000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/DSC5490_366cae08-c2c9-4f52-8510-eec6b829c380.jpg?width=360",h:"pandajqpo202511",nw:"09-03",up:"10-23",st:"revi"},
   {t:"カラフルキャンバストート4／猫",p:5000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/IMG_8698_241fea06-72d0-4157-9cb8-d8ee0b3a8fd8.jpg?width=360",h:"ccvtt2507",nw:"07-14",up:"07-14",st:"last"},
   {t:"ブルータンポポドライTシャツ",p:5500,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/0CC9346F-02A9-44C4-95C6-7B8E05519D09.jpg?width=360",h:"tbtdyt",nw:"07-21",up:"07-21",st:"last"},
   {t:"朧朧国マルチウェイスカーフ",p:12000,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/IMG_2282_a8bb8826-5e90-432f-8306-3e38e69a4552.jpg?width=360",h:"mwsk2025rouroukoku",nw:"09-11",up:"09-11",st:"ok"},
   {t:"カラフルプリントチュニック",p:8800,i:"https://cdn.shopify.com/s/files/1/0775/3534/6969/files/IMG_6774.jpg?width=360",h:"カラフルプリントチュニック",nw:"07-29",up:"07-29",st:"few"}
  ];
  var BADGE={last:{cls:"kura",label:"蔵出し",sub:"一点もの"},few:{cls:"few",label:"残りわずか"},revi:{cls:"revi",label:"ふたたび"}};
  var yenS=function(n){return "¥"+n.toLocaleString("ja-JP")};
  var key=function(d){var a=d.split("-");return (+a[0])*100+(+a[1])};
  var VIEWS=[["all","すべて"],["last","蔵出し"],["few","残りわずか"],["revi","ふたたび"]];
  var view="all",sort="up";
  function list(){
    var arr=P.filter(function(x){return view==="all"?x.st!=="last":x.st===view});
    if(sort==="new")return arr.slice().sort(function(a,b){return key(b.nw)-key(a.nw)});
    if(sort==="up")return arr.slice().sort(function(a,b){return key(b.up)-key(a.up)});
    return arr;
  }
  function count(v){return P.filter(function(x){return v==="all"?x.st!=="last":x.st===v}).length}
  function card(x){var b=BADGE[x.st];return '<a href="https://rourou.com/products/'+encodeURIComponent(x.h)+'" target="_blank" rel="noopener"><div class="im">'+(b?'<span class="gbadge '+b.cls+'">'+b.label+(b.sub?'<small>'+b.sub+'</small>':"")+'</span>':"")+'<img src="'+x.i+'" alt="'+x.t+'" loading="lazy"></div><p>'+x.t+'<span class="pr">'+yenS(x.p)+'</span></p></a>'}
  var NOTE={
    all:"「更新した順」＝在庫を足した品が自動で上に戻ります（見本では日付で再現）。蔵出しの品はこの棚からは外れ、「蔵出し」に集まります。",
    last:"定番シリーズで残り1柄になった品を自動で集めた棚です。一点もの。ここでだけ売り続けます（元の棚からは外れます）。",
    few:"在庫が残りわずか（2点以下）の品。値引きはせず「人気で残りわずか」。売り切れと一点ものは出ません。",
    revi:"完売していた人気の品が再入荷すると、しばらくの間ここに出ます（期間がすぎると自動で消えます）。"
  };
  function draw(){
    (document.getElementById("shopChips")||{}).innerHTML =VIEWS.map(function(v){return '<button type="button" data-v="'+v[0]+'" aria-pressed="'+(v[0]===view)+'">'+v[1]+'<small>'+count(v[0])+'</small></button>'}).join("");
    (document.getElementById("shopGoods")||{}).innerHTML =list().map(card).join("");
    (document.getElementById("shopNote")||{}).textContent =NOTE[view]||"";
    document.querySelectorAll("#shopChips button").forEach(function(b){b.onclick=function(){view=b.dataset.v;draw()}});
  }
  document.getElementById("shopSort").addEventListener("change",function(e){sort=e.target.value;draw()});
  draw();
})();

/* かたまり11 */

/* いまの棚から＝本店の /products.json から。どちらも新しい順に4点。
   蔵出し＝もともと2柄以上あって残り1柄（柄はバリアントなので、在庫のあるバリアントの数で見る）
   残りわずか＝通販在庫が1〜2点（rr-qty.json の実数。🔴 柄の数ではない。
     2026-11-03 までは「残り2柄」で代用していたが、在庫が読めるようになったので実数に直した）
   蔵出しに出た品は残りわずかには出さない */
(function(){
  const tl=document.getElementById("tsLast"), tf=document.getElementById("tsFew");
  if(!tl||!tf) return;
  const yen=n=>"¥"+Number(n).toLocaleString("ja-JP");
  const thumb=u=>u?(u+(u.indexOf("?")>-1?"&":"?")+"width=480"):"";
  const card=p=>{ const im=(p.images&&p.images[0]&&p.images[0].src)||"";
    return '<a href="/products/'+p.handle+'"><div class="im"><img src="'+thumb(im)+'" alt="'+p.title.replace(/"/g,"&quot;")+'" loading="lazy"></div><p>'+p.title+'<span class="pr">'+yen(Math.round(Number(p.variants[0].price)))+'</span></p></a>'; };
  fetch("/products.json?limit=250").then(function(r){return r.json()}).then(function(d){
    const ps=d.products.filter(function(p){return p.variants.some(function(v){return v.available})});
    const alive=function(p){ return p.variants.filter(function(v){return v.available}).length };
    ps.sort(function(a,b){ return new Date(b.published_at)-new Date(a.published_at) });
    const last=ps.filter(function(p){ return p.variants.length>=2 && alive(p)===1 }).slice(0,4);
    const seen={}; last.forEach(function(p){ seen[p.handle]=1 });
    const Q=window.RRQTY||{};
    const few=ps.filter(function(p){ var q=Q[p.handle];
      return !seen[p.handle] && typeof q==="number" && q>=1 && q<=2 }).slice(0,4);
    tl.innerHTML=last.map(card).join("");
    tf.innerHTML=few.map(card).join("");
    // 片方が空なら、その小見出しごと出さない
    if(!last.length) tl.closest(".tsh-block").hidden=true;
    if(!few.length) tf.closest(".tsh-block").hidden=true;
  }).catch(function(e){ console.warn("いまの棚からの読み込みに失敗",e) });
})();
/* 第1弾はトップ1ページだけ。1枚ものの名残のページ切替は何もしない */
try{showPage=function(){}}catch(e){}
/* ヘッダーの本物のページへのリンク（商品一覧・カート・English）は、1枚もの用のクリック横取りより先に走らせて確実に移る */
document.querySelectorAll('header.hd a[href^="/"]').forEach(function(a){
  a.addEventListener("click",function(e){e.stopImmediatePropagation();location.href=a.getAttribute("href")},true);
});

/* Xの投稿＝あらかじめ取って貯めた rr-x-posts.json から3件。Xが制限をかけている間も前の分が出続ける */
(function(){
  const box=document.getElementById("x-feed"); if(!box) return;
  fetch("//rourou.com/cdn/shop/t/34/assets/rr-x-posts.json?v=64537403445161683171793664300").then(function(r){return r.json()}).then(function(d){
    /* 🔴 古い投稿は出さない。終わった催事の告知が出続ける事故を止める関門（2026-11-01）
          ・取れた時刻が48時間より古い＝貯めた物が腐っている → 何も出さない
          ・投稿そのものが7日より古い → その投稿は出さない
          ・残り0件 → 枠は空のまま（「Xの投稿をすべて見る」のリンクだけ残る） */
    const now=Date.now();
    const at=Date.parse(String(d.at||"").replace(/\./g,"/").replace(" ","T"));
    if(at && now-at > 48*36e5){ console.warn("Xの投稿が古いので出しません（取れた時刻",d.at,"）"); return; }
    const ps=(d.posts||[]).filter(function(p){
      const t=Date.parse(String(p.d||"").replace(/\./g,"/"));
      return t && now-t < 7*864e5;
    }).slice(0,3);
    if(!ps.length){ console.warn("7日以内のXの投稿が無いので出しません"); return; }
    box.innerHTML=ps.map(function(p){
      const img=p.i?'<img src="'+p.i+'" alt="" loading="lazy">':'';
      return '<a class="xp" href="'+p.u+'" target="_blank" rel="noopener">'+img+
             '<span class="xpd">'+p.d+'</span><span class="xpt">'+
             p.t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/\n/g," ")+'</span></a>';
    }).join("");
  }).catch(function(e){ console.warn("Xの投稿の読み込みに失敗",e) });
})();
